<template>
  <v-dialog
    v-model="dialog"
    width="448"
    open-on-focus
    no-click-animation
    persistent
    content-class="new-chat-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <new-chat-dialog-header
        :is-visible="dialog"
        :step="step"
        :selected-contacts="selectedContacts"
        :participants-summary="participantsSummary"
        :subject-text="subjectText"
        :subject-text-is-valid="subjectTextIsValid"
        :contact-selected="contactSelected"
        :search-text="searchText"
        :current-channel-data="currentChannelData"
        :contact-single-selection="contactSingleSelection"
        @onPreviousStep="onPreviousStep"
        @closeDialog="closeDialog"
        @onChatSubject="onChatSubject"
        @onCreateChat="onCreateChat"
        @contact:search="$emit('contact:search', $event)"
        @contact:selection="$emit('contact:selection', $event)"
      />
      <new-chat-dialog-body
        :step="step"
        :loading="loading"
        :contacts="contacts"
        :contact-selected="contactSelected"
        :selected-contacts="selectedContacts"
        :disable-selection="numberOfSelectedContacts >= selectedContactsLimit"
        :participants-summary="participantsSummary"
        :contact-single-selection="contactSingleSelection"
        @onNextStep="onNextStep"
        @contact:selection="$emit('contact:selection', $event)"
        @contact-selection="$emit('contact:selection', $event)"
        @setContactSelectionOptionIsSingle="
          $emit('setContactSelectionOptionIsSingle', $event)
        "
      />
    </v-card>
  </v-dialog>
</template>

<script>
import NewChatDialogHeader from '@/components/chat/components/NewChatDialogHeader'
import NewChatDialogBody from '@/components/chat/components/NewChatDialogBody'

export default {
  name: 'NewChatDialog',
  components: {
    NewChatDialogHeader,
    NewChatDialogBody,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    contacts: {
      type: Array,
      default: () => [],
    },
    selectedContacts: {
      type: Array,
      default: () => [],
    },
    selectedContactsLimit: {
      type: Number,
      default: 49,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      default: 1,
    },
    currentChannelData: {
      type: Object,
      default: () => ({}),
    },
    contactSingleSelection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      subjectText: '',
      searchText: '',
    }
  },
  computed: {
    contactSelected() {
      return this.numberOfSelectedContacts !== 0
    },
    numberOfSelectedContacts() {
      return this.selectedContacts.length
    },
    subjectTextIsValid() {
      return this.contactSingleSelection ? true : this.subjectText.length > 2
    },
    participantsSummary() {
      const isFreeUser = this.selectedContacts.find(user => user.isFreeUser)
      const lengthOfUsers = this.contacts.length + (isFreeUser ? 1 : 0)

      return `Chat members ${this.numberOfSelectedContacts} of ${lengthOfUsers}`
    },
  },
  watch: {
    showDialog(val) {
      if (val) {
        this.dialog = val
        const name = this.currentChannelData.name
        if (name && this.step > 2) {
          this.subjectText = name
        }
      } else {
        this.closeDialog()
      }
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false
      this.subjectText = ''
      this.searchText = ''
      this.$emit('contact:search', '')
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.closeDialog()
    },
    onNextStep() {
      this.$emit('onDialogNextStep')
    },
    onPreviousStep() {
      this.$emit('onDialogPreviousStep')
    },
    onChatSubject(value) {
      this.subjectText = value
    },
    onCreateChat() {
      const selectedContacts = [...this.selectedContacts]
      this.$emit('on-submit', {
        contacts: selectedContacts,
        subject: this.subjectText,
      })
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.new-chat {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2 * $gutter}) !important;
    > .v-card {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      border-radius: 16px;
      overflow: hidden;
    }
  }
}
</style>
